<template>
  <div class="metric-block">
    <div
      v-if="block.label"
      class="metric-label"
      data-testid="ai-chat-metric-label"
    >
      {{ block.label }}
    </div>
    <div class="flex items-baseline metric-row">
      <span class="metric-value" data-testid="ai-chat-metric-value">
        {{ formatValue(block.value, block.unit) }}
      </span>
      <diff-badge
        v-if="hasPrevious"
        :diff="block.diffPercent"
        has-arrow
        data-testid="ai-chat-metric-diff-badge"
      />
    </div>
    <div
      v-if="hasPrevious"
      class="metric-previous"
      data-testid="ai-chat-metric-previous"
    >
      {{
        t('aichat.main.blocks.metric.previous', {
          value: formatValue(block.previous ?? 0, block.unit)
        })
      }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import DiffBadge from '@shared/components/diff-badge/index.vue'
import type { MetricBlock } from '../../types'
import { useFormatValue } from './format'

/* the KPI tile: the home widgets' big value, their change badge and the previous period's value; a widget's metric has no label, its card carries the title */
const props = defineProps<{
  block: MetricBlock
}>()

const { t } = useI18n()
const formatValue = useFormatValue()

const hasPrevious = computed(
  () => props.block.previous !== undefined && props.block.previous !== null
)
</script>

<style scoped>
.metric-label {
  color: var(--el-text-color-secondary);
  font-size: 0.75rem;
}

.metric-row {
  gap: 0.625rem;
}

.metric-value {
  color: var(--el-text-color-primary);
  font-size: 1.5rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.metric-previous {
  margin-top: 0.125rem;
  color: var(--el-text-color-secondary);
  font-size: 0.75rem;
}
</style>
